module.exports = __webpack_public_path__ + "img/mastercard.f68b268e.png";